/* eslint-disable react/no-unknown-property */
import React from 'react';
import { IconsPropsType } from './icons.config.type';

const FromHigherInjection: React.FC<IconsPropsType> = ({ style, color, onClick, className }) => {
  return (
    <svg
      style={{ ...style }}
      width="20"
      height="42"
      viewBox="0 0 20 42"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="19" height="29" rx="2.5" stroke="black" />
      <path
        d="M10 15.6001L4 25.3223H7.32667L7.33333 40.6001H12.6667V25.3223H16L10 15.6001Z"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    // </div>
  );
};

FromHigherInjection.defaultProps = {
  style: { width: '20px', height: '42px' },
  color: '#fff',
  onClick: undefined,
  className: undefined,
};

export default FromHigherInjection;
